module.exports = __webpack_public_path__ + "img/green_111.b1eb606a.png";